import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { toast } from 'react-toastify';
import { ApiCreateOrUpdateHoliday, ApiDeleteHoliday, ApiGetHoliday } from '../../../apiService/Core/Apicall.tsx';
const stateOptions = [
    { label: "Victoria", value: "VIC" },
    { label: "Western Australia", value: "WA" },
    { label: "South Australia", value: "SA" },
    { label: "Queensland", value: "QLD" },
    { label: "Australian Capital Territory", value: "ACT" },
    { label: "New South Wales", value: "NSW" },
    { label: "Tasmania", value: "TAS" },
    { label: "Northern Territory", value: "NT" },
];

function ManageHoliday() {
    const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
    const [selectedState, setSelectedState] = useState("");
    const [open, setOpen] = useState(false);
    const [selectedStates, setSelectedStates] = useState<string[]>([]);
    const [selectAllStates, setSelectAllStates] = useState(false);
    const [createselectedDate, setcreateSelectedDate] = useState<Date | null>(new Date());
    const [isEditMode, setIsEditMode] = useState(false);
    const [holidayType, setHolidayType] = useState('');
    const [holidayData, setHolidayData] = useState<any[]>([]);
    const [holidayId, setholidayId] = useState(null)
    const [previousData, setPreviousData] = useState<any>(null);


    const handleClose = () => setOpen(false)

    const handleSelectAllStates = (event: React.ChangeEvent<HTMLInputElement>) => {
        const checked = event.target.checked;
        setSelectAllStates(checked);
        setSelectedStates(checked ? stateOptions.map((s) => s.value) : []);
    };

    const handleToggleState = (stateValue: string) => {
        setSelectedStates((prev) => {
            const updated = prev.includes(stateValue)
                ? prev.filter((val) => val !== stateValue)
                : [...prev, stateValue];
            setSelectAllStates(updated.length === stateOptions.length);
            return updated;
        });
    };

    const handleCreate = async () => {
        const formatDateToYMD = (date: Date | null): string => {
            if (!date) return '';
            const year = date.getFullYear();
            const month = `${date.getMonth() + 1}`.padStart(2, '0');
            const day = `${date.getDate()}`.padStart(2, '0');
            return `${year}/${month}/${day}`;
        };
        const formattedDate = formatDateToYMD(createselectedDate);
        if (isEditMode) {
            try {
                const data: any = { holidayId: Number(holidayId) };
                if (
                    !previousData ||
                    previousData.date.toISOString().slice(0, 10) !== createselectedDate?.toISOString().slice(0, 10)
                ) {
                    data.date = formattedDate;
                }

                if (!previousData || previousData.type !== holidayType) {
                    data.type = holidayType;
                }

                if (
                    !previousData ||
                    previousData.state.sort().join(',') !== selectedStates.sort().join(',')
                ) {
                    data.state = selectedStates.join(',');
                }

                if (Object.keys(data).length === 1) {
                    toast.info("No changes made.");
                    return;
                }
                await ApiCreateOrUpdateHoliday(data);

                toast.success("Holiday Updated Successfully.");
                setOpen(false);
                hangleGetHolidays()
                setcreateSelectedDate(new Date());
                setHolidayType('');
                setSelectedStates([]);
                setSelectAllStates(false);
                setPreviousData(null);
            } catch (error) {
                setOpen(false);
                toast.error("Error Updating Holidays.");
                console.error("Error during API call:", error);
            }

        } else {
            try {
                const data = {
                    date: formattedDate,
                    type: holidayType,
                    state: selectedStates.join(',')
                }
                await ApiCreateOrUpdateHoliday(data)
                toast.success("Holiday Created Successfully.")
                setOpen(false);
                hangleGetHolidays()
                setcreateSelectedDate(new Date());
                setHolidayType('');
                setSelectedStates([]);
                setSelectAllStates(false);
            } catch (error) {
                setOpen(false);
                toast.error("Error Creating Holidays.");
                console.error("Error during API call:", error);
            }
        }
    }
    const hangleGetHolidays = async () => {
        try {
            const year = selectedDate ? selectedDate.getFullYear() : new Date().getFullYear();
            const data = `?year=${year}${selectedState ? `&state=${selectedState}` : ""}`
            const res = await ApiGetHoliday(data);
            setHolidayData(res?.data);
        } catch (error) {
            toast.error("Error Generating Holidays.")
            console.error("Error getting Holidays.", error);
        }
    }
    useEffect(() => {
        hangleGetHolidays()
    }, [selectedDate, selectedState])
    const handleDelete = async(holidayId:Number) => {
        try {
            const data = `?holidayId=${holidayId}`
            await ApiDeleteHoliday(data);
            toast.success("Holiday deleted Successfully.")
            hangleGetHolidays();
        } catch (error) {
            toast.error("Error Deleting Holidays.")
            console.error("Error Deleting Holidays.", error);
        }
    }
    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box className='manage-button'>
                <h1>Manage Holidays</h1>
                <Box className='d-flex add-button common-manage-button h-50' gap={1}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={["year"]}
                            label="Select Date"
                            value={selectedDate}
                            onChange={(newDate) => setSelectedDate(newDate)}
                            format="yyyy"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 1,
                                }
                            }}
                        />
                    </LocalizationProvider>
                    <Stack className="ml-0" direction="row" spacing={2}>
                        <FormControl size="medium" sx={{ width: 200 }}>
                            <Autocomplete
                                options={stateOptions}
                                getOptionLabel={(option) => option.label}
                                value={stateOptions.find((option) => option.value === selectedState) || null}
                                onChange={(event, newValue) => {
                                    setSelectedState(newValue?.value || "");
                                }}
                                renderInput={(params) => <TextField {...params} label="Select State" />}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                        </FormControl>
                    </Stack>
                    <Button
                        variant='contained'
                        className='table-row-background py-3 '
                        onClick={() => {
                            setIsEditMode(false);
                            setcreateSelectedDate(new Date());
                            setHolidayType('');
                            setSelectedStates([]);
                            setSelectAllStates(false);
                            setOpen(true);
                        }}
                    >
                        Create
                    </Button>
                </Box>
            </Box>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle style={{ textAlign: "center" }}>
                    {isEditMode ? "Update Holiday" : "Create Holiday"}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ paddingTop: '10px' }}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Select Date"
                                value={createselectedDate}
                                onChange={(newDate) => setcreateSelectedDate(newDate)}
                                format="dd/MM/yyyy"
                                sx={{
                                    width: '100%',
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: 1,
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box sx={{ marginTop: 2 }}>
                        <FormControlLabel
                            sx={{
                                '& .MuiFormControlLabel-label':
                                {
                                    fontWeight: 'bold'
                                }
                            }}
                            control={
                                <Checkbox
                                    checked={selectAllStates}
                                    onChange={handleSelectAllStates}
                                />
                            }
                            label="Select All States"
                        />
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {stateOptions.map((state) => (
                                <Box
                                    key={state.value}
                                    sx={{ width: 'calc(50% - 8px)', boxSizing: 'border-box' }}
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={selectedStates.includes(state.value)}
                                                onChange={() => handleToggleState(state.value)}
                                            />
                                        }
                                        label={state.label}
                                    />
                                </Box>
                            ))}
                        </Box>
                    </Box>
                    <TextField
                        label="Type"
                        fullWidth
                        size="small"
                        sx={{ marginTop: '20px' }}
                        value={holidayType}
                        onChange={(e) => setHolidayType(e.target.value)}
                    />

                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>
                    <Button
                        variant="outlined"
                        sx={{ color: '#75724C', borderColor: '#75724C', width: '100%' }}
                        onClick={() => {
                            setOpen(false)
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className='table-row-background'
                        sx={{ width: '100%' }}
                        onClick={() => {
                            handleCreate()
                        }}
                    >
                        {isEditMode ? "Update" : "Create"}
                    </Button>
                </DialogActions>
            </Dialog>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#75724C" }}>
                        <TableCell sx={{ color: "#fff", width: "10%" }}></TableCell>
                        <TableCell sx={{ color: "#fff", width: "30%" }}>Holiday Date</TableCell>
                        <TableCell sx={{ color: "#fff", width: "30%" }}>Holiday Type</TableCell>
                        <TableCell sx={{ color: "#fff", width: "20%" }}>State</TableCell>
                        <TableCell sx={{ color: "#fff", width: "10%" }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {holidayData.map((holiday) => (
                        <TableRow key={''} sx={{ borderBottom: "1px solid #c0bfa2" }}>
                            <TableCell sx={{ width: "10%" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className='table-row-background'
                                    onClick={()=> {
                                        handleDelete(holiday?.holidayId)
                                    }}
                                >
                                    Delete
                                </Button>
                            </TableCell>
                            <TableCell sx={{ width: "30%" }}>{new Date(holiday?.date).toLocaleDateString('en-GB')}</TableCell>
                            <TableCell sx={{ width: "30%" }}>{holiday?.holidayName}</TableCell>
                            <TableCell sx={{ width: "20%" }}>{holiday?.states}</TableCell>
                            <TableCell sx={{ width: "10%" }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className='table-row-background'
                                    onClick={() => {
                                        setIsEditMode(true);
                                        setholidayId(holiday?.holidayId)
                                        setcreateSelectedDate(new Date(holiday?.date));
                                        setHolidayType(holiday?.holidayName);
                                        setSelectedStates(holiday?.states?.split(','));
                                        setSelectAllStates(holiday?.states.split(',').length === stateOptions.length);
                                        setPreviousData({
                                            holidayId: holiday?.holidayId,
                                            date: new Date(holiday?.date),
                                            type: holiday?.holidayName,
                                            state: holiday?.states.split(',')
                                        });
                                        setOpen(true);
                                    }}
                                >
                                    Update
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    )
}
export default ManageHoliday;